import React from "react";
import { NumericFormat } from "react-number-format";
import { Icon, InputAdornment, TextField } from "@mui/material";
import WeekPicker from "./ScheduleDate";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

function PostcardCampaignLocationBudget({
  onChangeWeek,
  locTotalCoast,
  initialWeek,
  disableWeekSelection,
  isEvergreenCampaign,
}) {
  return (
    <div className="card-footer bg-white">
      <div className="card border-0">
        <div className="card-body px-0 py-0">
          <div className="container-fluid p-0">
            <div className="row">
              <div className="col-lg-4 py-2 scheduled-date week-picker">
                <label>Scheduled Date (PST)</label>
                <br />
                <WeekPicker
                  onChange={onChangeWeek}
                  initialVal={initialWeek}
                  disableWeekSelection={disableWeekSelection}
                  isEvergreenCampaign={isEvergreenCampaign}
                />
              </div>
              <div className="col-lg-4"></div>
              <div className="col-lg-4 Total-cost">
                <div className="row">
                  <div className="col-md">
                    <div className="location-budget">
                      <label>Total Cost</label>
                      <NumericFormat
                        customInput={TextField}
                        value={locTotalCoast ?? 0}
                        name="totalCost"
                        id="totalCost"
                        thousandSeparator
                        decimalScale={2}
                        allowNegative={false}
                        prefix="$"
                        suffix=" USD"
                        isAllowed={({ floatValue }) =>
                          floatValue === undefined || floatValue <= 1000000
                        }
                        slotProps={{
                          input: {
                            startAdornment: (
                              <InputAdornment position="start">
                                <Icon
                                  component={RpSvgIcon}
                                  name="money1"
                                  color="primary"
                                />
                              </InputAdornment>
                            ),
                          },
                        }}
                        variant="outlined"
                        size="small"
                        autoComplete="off"
                        placeholder="0.00"
                        disabled
                      />
                      {/* {minMaxRequired && value !== "" ? (
                            <FormHelperText>{`Enter a budget between $${minMaxRequired.minRequiredBudget} & $${minMaxRequired.maxRequiredBudget}`}</FormHelperText>
                          ) : null} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PostcardCampaignLocationBudget;
